import React from 'react';
import { Slide } from 'react-reveal';
import OurGainCart from './OurGainCart';

const gainData = [
    {
        gainLogo: "https://i.ibb.co/FWC0VDJ/teacher.webp",
        numberCount: "150 +",
        title: "আমাদের অর্জন"
    },
    {
        gainLogo: "https://i.ibb.co/HnJsZTj/content.webp",
        numberCount: "২৮ হাজার",
        title: " ভিডিও"
    },
    {
        gainLogo: "https://i.ibb.co/cLq6jkq/user.webp",
        numberCount: "৪১ লক্ষ",
        title: "অ্যাপ ব্যবহারকারী"
    },
    {
        gainLogo: "https://i.ibb.co/9HXJC6g/student.webp",
        numberCount: "৯৩ লক্ষ ",
        title: "শিক্ষার্থী"
    }
]

const OurGain = () => {
    return (
        <div className='container-fluid p-5' style={{ marginTop: "80px" }}>
            <Slide left>
                <h3 className='fw-bold fs-2 text-center'>আমাদের অর্জন</h3>
            </Slide>

            <div className="row">
                <div className="col-lg-4 col-md-3 col-sm-12 col-12">
                    <div className="logo2">
                        <img src='https://i.ibb.co/ZmTgC4D/career.webp' alt="student gainLogo" className='img-fluid d-block mx-auto' />
                    </div>
                </div>
                <div className="col-lg-8 col-md-9 col-sm-12 col-12">
                    <div className="gaindev" style={{ marginTop: '100px' }}>
                        <div className="row gy-3">
                            {
                                gainData?.map(gain => <OurGainCart gain={gain} key={gain.title} />)
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OurGain;